'use client';

import { Label } from '@radix-ui/react-label';
import { Briefcase, Refresh2 } from 'iconsax-react';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { BuyTabsEnum, goldAssetsLanguages } from '@entities/asset';
import { FeatureFlagEnum, FeatureToggle } from '@shared/featureManagment';
import { useMobile } from '@shared/hooks';
import { NotFound, Tabs } from '@shared/ui';

export const GoldAssetLayout = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();
  const isMobile = useMobile();

  const getActiveTab = (pathname: string): BuyTabsEnum => {
    switch (true) {
      case pathname.includes('/gold/history'):
        return BuyTabsEnum.RequestHistory;

      case pathname.includes('/gold'):
        return BuyTabsEnum.assets;

      default:
        return BuyTabsEnum.assets;
    }
  };

  const activeTab = getActiveTab(pathname);

  return (
    <FeatureToggle flag={FeatureFlagEnum.insuranceEnabled} fallback={<NotFound />}>
      {isMobile ? (
        <>{children}</>
      ) : (
        <div className='flex flex-col gap-4 layout !pt-9'>
          <header className='flex items-center gap-1'>
            <div className='h-[38px] w-[38px] border border-border rounded-full flex items-center justify-center'>
              <Image src='/resources/goldbar.png' alt='goldbar' width={32} height={32} />
            </div>
            <Label className='h4-bold'>{goldAssetsLanguages.goldPaln}</Label>
          </header>

          <Tabs key={activeTab} defaultValue={activeTab} varient='line'>
            <Tabs.List>
              <Tabs.Trigger value={1} className='p-0'>
                <Link href='/assets/gold' className='w-full h-full flex items-center gap-1 px-3 py-2'>
                  <Briefcase size={14} />
                  {goldAssetsLanguages.assets}
                </Link>
              </Tabs.Trigger>

              <Tabs.Trigger value={2} className='p-0'>
                <Link
                  href='/assets/gold/history'
                  className='w-full h-full flex items-center gap-1 px-3 py-2'
                >
                  <Refresh2 size={12} />
                  {goldAssetsLanguages.requestHistory}
                </Link>
              </Tabs.Trigger>
            </Tabs.List>

            <div>{children}</div>
          </Tabs>
        </div>
      )}
    </FeatureToggle>
  );
};
